@if (accessBlockService.blockState(); as blockState) {
  <div class="access-block-overlay" aria-modal="true" role="alertdialog">
    <div class="access-block-card">
      <div class="access-block-logo">
        <img src="assets/logo/logo.svg" alt="Ministrary" draggable="false" />
      </div>

      <h1>{{ blockState.title }}</h1>
      <p>{{ blockState.message }}</p>

      @if (blockState.contactHref) {
        <p class="access-block-contact">
          {{ blockState.contactIntro }}<a [href]="blockState.contactHref" target="_blank" rel="noopener noreferrer">{{ blockState.contactLabel }}</a>{{ blockState.contactOutro }}
        </p>

        <a class="access-block-button" [href]="blockState.contactHref" target="_blank" rel="noopener noreferrer">
          {{ blockState.contactCtaLabel }}
        </a>
      }
    </div>
  </div>
}
